const Card = require('./models/Card');

/**
 * Calculates the sum of all array elements in the array of numbers
 * @param  {number[]} array array of numbers
 * @returns {number}
 */
function arraySum(array) {
	return array.reduce((acc, curr) => acc + curr, 0);
}

/**
 * Checks whether an array contains objects that have the same value of a given property
 * @param  {any[]} array array of objects
 * @param  {string} prop property name
 * @returns {boolean}
 *
 * @example
 * isSamePropValue([{ value: 1 }, { value: 1 }, { value: 1 }], 'value') // returns true
 * isSamePropValue([{ value: 1 }, { value: 2 }, { value: 1 }], 'value') // returns false
 */
function isSamePropValue(array, prop) {
	return array.every((obj) => obj[prop] === array[0][prop]);
}

function getLowestRank(ranks) {
	return [...ranks]
		.sort((a, b) => Card.RANKS[a].rankOrder - Card.RANKS[b].rankOrder)
		.at(0);
}

/**
 * @returns Card[]
 * */
function convertDDSPlaysToCards(plays) {
	const cards = [];

	for (const play of plays) {
		cards.push(new Card(play.rank, play.suit));

		if (play.equals && Array.isArray(play.equals)) {
			for (const equalRank of play.equals) {
				cards.push(new Card(equalRank, play.suit));
			}
		}
	}

	return cards;
}

/**
 * @returns {Card | null}
 * */
function getLowestPlayCard(plays) {
	return convertDDSPlaysToCards(plays).sort(Card.compare).at(0) || null;
}

function getPlaysBySuit(plays, suit) {
	return plays.filter((play) => play.suit === suit);
}

function getPlaysBySuits(plays, suits) {
	for (const suit of suits) {
		const playsBySuit = getPlaysBySuit(plays, suit);
		if (playsBySuit.length) {
			return playsBySuit;
		}
	}

	return [];
}

/**
 * Returns the intersection of two arrays
 * @param {any[]} arr1 array of items
 * @param {any[]} arr2 array of items
 * @returns {any[]}
 */
function intersection(arr1, arr2) {
	return [...new Set(arr1.filter((item) => arr2.includes(item)))];
}

function getMaxScorePlays(plays) {
	const maxScore = plays.reduce((max, current) => {
		return Math.max(max, current.score);
	}, -Infinity);
	return plays.filter((play) => play.score === maxScore);
}

module.exports = {
	arraySum,
	isSamePropValue,
	getLowestRank,
	convertDDSPlaysToCards,
	getLowestPlayCard,
	getPlaysBySuit,
	getPlaysBySuits,
	intersection,
	getMaxScorePlays,
};
